import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MatIconRegistry } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "@env/environment";

@Component({
  selector: "app-root",
  template:
    '<router-outlet></router-outlet><simple-notifications [options]="notificationOptions"></simple-notifications>',
})
export class AppComponent {
  notificationOptions = {
    timeOut: 3000,
  };

  constructor(
    translate: TranslateService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    const supportedLangs = environment.SUPPORTED_LANGUAGES.map(
      (entry) => entry.lang,
    );
    const defaultLang = environment.DEFAULT_LANG;

    translate.addLangs(supportedLangs);
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(defaultLang);

    // try to read lang from the localstorage
    let lang = localStorage.getItem("lang");

    if (!lang) {
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      lang = translate.getBrowserLang();
    }

    translate.use(supportedLangs.includes(lang) ? lang : defaultLang);

    // add icons
    iconRegistry.addSvgIcon(
      "doctor",
      sanitizer.bypassSecurityTrustResourceUrl(
        "/assets/images/icons/doctor.svg",
      ),
    );
    iconRegistry.addSvgIcon(
      "help",
      sanitizer.bypassSecurityTrustResourceUrl("/assets/images/icons/help.svg"),
    );
    iconRegistry.addSvgIcon(
      "notifications",
      sanitizer.bypassSecurityTrustResourceUrl(
        "/assets/images/icons/notifications.svg",
      ),
    );
    iconRegistry.addSvgIcon(
      "documents",
      sanitizer.bypassSecurityTrustResourceUrl(
        "/assets/images/icons/documents.svg",
      ),
    );
    iconRegistry.addSvgIcon(
      "price",
      sanitizer.bypassSecurityTrustResourceUrl(
        "/assets/images/icons/price.svg",
      ),
    );
    iconRegistry.addSvgIcon(
      "plans",
      sanitizer.bypassSecurityTrustResourceUrl(
        "/assets/images/icons/plans.svg",
      ),
    );
    iconRegistry.addSvgIcon(
      "custom-treatments",
      sanitizer.bypassSecurityTrustResourceUrl(
        "/assets/images/icons/custom-treatment.svg",
      ),
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts